
import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Index from '@/pages/Index';
import NotFound from '@/pages/NotFound';
import Analytics from '@/pages/Analytics';
import { Toaster } from "@/components/ui/sonner";

const App = () => {
  console.log("App component rendering - updated");
  
  useEffect(() => {
    console.log("App component mounted");
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster />
    </>
  );
};

export default App;
